// LegacyApi — 과거 v4 / gltf-json 시대 모델 API (보관용 아카이브).
//  당시 모델은 gltf(json) + 외부 bin/텍스처 형식이었고 경로 규칙이 `models/v4/{idx}_v4/{idx}_v4.gltf` 였다.
//  현재 메인 흐름은 v5 glb(자기완결 바이너리) + AppModelFacade.fetchModel(= BaseApi.fetchModelArrayBuffer)로 대체됨.
//  ⚠️ 신규 코드에서 쓰지 말 것. OneModelCard / ModelLoadingPage 등 레거시 표면만 참조.
import { ALL_MODEL_INDEXES } from "@/constants";
import APP_CAMERA_POSITIONS from "@/constants/APP_CAMERA_POSITIONS";
import { isLocal } from "@/utils/env-utils";
import axios from "axios";

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

// 과거 라이선스/프로필 mock. (항상 premium 반환 — 실제 권한 판단 미연결)
export const fetchProfile = async () => {
  await delay(1000);
  return {
    isPremiumUser: true,
    expireLicenseDate: "",
  };
};

// modelIndex → v4 gltf CDN 키
function getModelUrl(modelIndex) {
  const version = "v4";
  return `models/${version}/${modelIndex}_${version}/${modelIndex}_${version}.gltf`;
}

function getCameraPosition(modelIndex) {
  const NEED_ZOOM_OUT = ["deer", "donkey", "horse", "zebra", "rabbit"];
  if (NEED_ZOOM_OUT.includes(modelIndex)) {
    return APP_CAMERA_POSITIONS.ZOOM_OUT_1;
  } else {
    return APP_CAMERA_POSITIONS.ZOOM_IN_1;
  }
}

function getPrimaryColor(modelIndex) {
  if (modelIndex === "rabbit") return "#ff5b6f";
  else if (modelIndex === "tiger") return "#ff9f4d";
  else if (modelIndex === "fox") return "#ff9f4d";
  else if (modelIndex === "dog2") return "#b6653b";
  else if (modelIndex === "bear") return "#b6653b";
  else if (modelIndex === "cow") return "red";
  else if (modelIndex === "monkey") return "brown";
  else return "#b6653b";
}

export const fetchMyModelMetadata = async (modelIndex = "") => {
  const [a] = modelIndex.split("_"); // fox_v5 대응
  modelIndex = a;

  if (isLocal() && modelIndex === undefined) modelIndex = "unicorn";

  if (ALL_MODEL_INDEXES.includes(modelIndex)) {
    const cameraPosition = getCameraPosition(modelIndex);
    const color = getPrimaryColor(modelIndex);
    const url = getModelUrl(modelIndex);
    return {
      primaryColor: color,
      modelUrl: url,
      cameraPosition,
    };
    // SAMPLE MODEL
  } else if (["cat", "child", "sample"].includes(modelIndex)) {
    return loadLegacy(modelIndex);
  } else {
    throw new Error(`E_NOT_SUPPORTED_MODEL_INDEX : ${modelIndex}`);
  }
};

// gltf(json) fetch — Content-Type: model/gltf+json. (v5 glb는 BaseApi.fetchModelArrayBuffer 사용)
export const fetchModel = async (url) => {
  const { data } = await axios.get(url, {
    onDownloadProgress: () => {},
  });
  return data;
};

function loadLegacy(modelIndex) {
  // extra models (샘플)
  if (modelIndex === "cat") {
    return {
      primaryColor: "#9155fd",
      // Electron에서 로컬 파일을 읽을 수 있도록 '/' 있으면 file:// 로 시작하는 url로 인식한다. 없으면 C://
      modelUrl: "models/sample_cat/cat.gltf",
      cameraPosition: { x: 3, y: 4, z: 8.5 },
    };
  } else if (modelIndex === "child") {
    return {
      primaryColor: "#508345",
      modelUrl: "models/sample_child/anim5.gltf",
      cameraPosition: { x: 3, y: 4, z: 8.5 * 40 },
    };
  } else if (modelIndex === "sample") {
    return {
      primaryColor: "#bf7b5a",
      modelUrl: "models/sample/sample.gltf",
      cameraPosition: {
        x: 0.34462566143723866,
        y: 0.8573113065464888,
        z: 1.718044448155407,
        _x: -0.08861077948998768,
        _y: 0.5241708098872303,
        _z: -0.2821844891225064,
      },
    };
  }
}

export default {
  fetchProfile,
  fetchMyModelMetadata,
  fetchModel,
};
